import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Button, Text } from 'ui';
import AuthFormWrapper from 'ui/layouts/AuthFormWrapper';

import s from './ErrorComponent.module.scss';

const cx = cn.bind(s);

const ErrorComponent = ({
  title, subtitle, text, className, ...attrs
}) => (
  <div >
    <AuthFormWrapper className={cx(className)} {...attrs}>
      <div className={cx(className, 'wrapper')} {...attrs}>
        {title && <div className={cx('title', 'tp-mobile-header-1 md:tp-header-1')}>{title}</div>}
        {subtitle && <Text as="h3" tag="div" className={cx('subtitle')}>{subtitle}</Text>}
        <Text tag="div" className={cx('text')}>{text}</Text>
        <div className={cx('action')}>
          <Button href="/" as="a">
            Go Back
          </Button>
        </div>
      </div>
    </AuthFormWrapper>
  </div>
);

ErrorComponent.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ErrorComponent;
